import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/footer/Footer';
import '../css/LegalPages.css';

const NotFound = () => (
    <>
        <Helmet>
            <title>Page introuvable | CC Débarras 14</title>
            <meta name="robots" content="noindex, follow" />
        </Helmet>

        <Header />
        <div className="legal-page">
            <div className="legal-content">
                <h1>Page introuvable</h1>
                <p>Cette page n'existe pas ou a été déplacée.</p>
                <p><Link to="/">Retour à l'accueil</Link> ou <Link to="/contact">demandez un devis gratuit</Link>.</p>
            </div>
        </div>
        <Footer />
    </>
);

export default NotFound;
